import { buildSubModuleRoute } from 'Arch/helpers/RouterHelper';
import Statemments from 'Modules/contacard/reports/statements/routes';
import Reports from 'Modules/contacard/reports/reports/routes';

export default [
  buildSubModuleRoute({
    moduleId: 'contacard',
    name: 'reports',
    path: 'reports/',
    subModuleTitle: 'Relatórios',
    children: [
      ...Statemments,
      ...Reports,
    ],
  }),
];
